import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ breadcrumbs = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="breadcrumb" style={{ marginTop: '8px', marginBottom: '8px' }}>
      <nav aria-label="breadcrumb">
        <ol style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0 }}>
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            const label = typeof crumb === 'string' ? crumb : crumb.label;
            const path = typeof crumb === 'string' ? null : crumb.path;

            return (
              <li
                key={index}
                onClick={() => !isLast && path && navigate(path)}

                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: !isLast && path ? 'pointer' : 'default',
                }}
                className={isLast ? 'active' : 'inactive'}
              >
                {label}
                {!isLast && (
                  <span style={{ margin: '0 8px', color: '#6c757d' }}>/</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string,
      }),
    ])
  ),
};

export default Breadcrumb;
